var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableScroll",class:[
		'table-scroll table--fixed-left',
		_vm.classes,
		{ 'table-will-scroll': _vm.addScrollClass }
	],attrs:{"id":_vm.componentId}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }